var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry, actionExecutionLocations) {
    pluginRegistry.registerDeploymentAction("Octopus.AzureCloudService", function(octopusRepository) {
        return {
            executionLocation: actionExecutionLocations.alwaysOnServer,
            canChooseRoles: true,
            canHaveChildren: function(){return true;},
            canBeChild: true,
            hasPackages: function(action) { return true; },
            features: {
                optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
                    "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles"]
            },
            summaryTemplateUrl: "areas/projects/actions/azure_cloud_service/Octopus.AzureCloudService_summary.html",
            editTemplateUrl: "areas/projects/actions/azure_cloud_service/Octopus.AzureCloudService_edit.html",

            preLink: function(scope) { 
                scope.account = {
                    AccountId: scope.action.Properties["Octopus.Action.Azure.AccountId"],
                    bound: {}
                };

                scope.azure = {
                    cloudServiceName: scope.action.Properties["Octopus.Action.Azure.CloudServiceName"],
                    storageAccountName: scope.action.Properties["Octopus.Action.Azure.StorageAccountName"],
                };

                if (scope.action.Properties["Octopus.Action.Azure.SubscriptionId"] && !scope.action.Properties["Octopus.Action.Azure.AccountId"]) {
                   scope.usingLegacySubscriptionId = true;
                } 

                scope.cloudServiceLockedToBound = function() {
                   return scope.account.bound.isBound || 
                        (scope.usingLegacySubscriptionId && !scope.action.Properties["Octopus.Action.Azure.AccountId"]);
                };

                scope.getAccountId = function() {
                    return (!scope.account.bound.isBound) ? scope.action.Properties["Octopus.Action.Azure.AccountId"] : undefined;
                };

                scope.reset = {
                    slot: "Staging",
                    account: undefined 
                };

                scope.$watch(function() {
                    return scope.account.AccountId;
                },
                function() {
                    if (scope.action) {
                        scope.action.Properties['Octopus.Action.Azure.AccountId'] = scope.account.AccountId;
                    }
                });

                scope.$watch(function() {
                    return scope.azure.cloudServiceName;
                },
                function() {
                    if (scope.action) {
                        scope.action.Properties["Octopus.Action.Azure.CloudServiceName"] = scope.azure.cloudServiceName;
                    }
                });

                scope.$watch(function() {
                    return scope.azure.storageAccountName;
                },
                function() {
                    if (scope.action) {
                        scope.action.Properties["Octopus.Action.Azure.StorageAccountName"] = scope.azure.storageAccountName;
                    }
                });
            },

            summaryLink: function($scope, element) {
                return octopusRepository.Feeds.get($scope.properties["Octopus.Action.Package.FeedId"]).then(function(feed){
                  $scope.feedName = feed.Name;
                });
            }
        };
    });
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/azure_cloud_service/Octopus.AzureCloudService.js
// module id = 377084959946477
// module chunks = 1